import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Styles } from "./styles/RegisterTable.js";
import { FormStyles } from "./styles/Register2.js";
import HeaderTwo from '../../components/HeaderTwo.js';
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import FooterTwo from '../../components/FooterTwo.js';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import service from "../../services/service";
import learnerService from '../../services/learnerService.js';
import ReactSelect from 'react-select';
import axios from 'axios';
import cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Modal1 from "react-modal";
import UserService from '../../services/UserService.js';
import adminServices from '../../services/adminServices.js';
import { BreadcrumbBox2 } from '../../components/common/Breadcrumb2.js';
import CryptoJS from "crypto-js";
import swal from 'sweetalert';
import { URI, USER_API } from '../../services/service';

const languages = [

    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },

    {
        code: 'hi',
        name: 'Hindi',
        country_code: 'in'
    },
    // {
    //     code: 'te',
    //     name: 'Telugu',
    //     country_code: 'in'
    // },
    {
        code: 'pu',
        name: 'Punjabi',
        country_code: 'in'
    },
    // {
    //     code : 'mr',
    //     name : 'Marathi',
    //     country_code : 'in'
    // }
]

const DropdownMenuComponent = ({
    onSelectionChange,
    getCourses,
    selectedValues
}) => {
    const handleChange = (selectedCourses) => {
        let selectedValues = selectedCourses.map((option) => option.value);
        onSelectionChange(selectedValues);
    };

    return (
        <Styles>
            <div className='form-field'>
                <Select
                    isMulti
                    options={getCourses}
                    value={getCourses?.filter((option) =>
                        selectedValues.includes(option.value)
                    )}
                    onChange={handleChange}
                    placeholder="Select Course(s)"
                />
            </div>
        </Styles>
    );
};


const RegisterTable = (props) => {

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
    const { t } = useTranslation()
    useEffect(() => {
        document.body.dir = currentLanguage.dir || 'ltr'
        document.title = t('app_title')
    }, [currentLanguage, t])
    Modal1.setAppElement('*');
    const history = useHistory();




    // let email = props.match.params.email;
    // let selectedCard = props.match.params.selectedCard;
    let tenantID = 1;
    let username = UserService.getUsername();

    const [email, setEmail] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null)

    const [showExcelTemplate, setShowExcelTemplate] = useState(false);
    const [showAddUsers, setShowAddUsers] = useState(false);

    const [isVerified, setIsVerified] = useState(false);


    const [userDetails, setUserDetails] = useState();
    const [multiUserDetails, setMultiUserDetails] = useState([{}, {}, {}, {}, {}]);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [getCourses, setCourses] = useState([]);
    const [getCoursesCompleteData, setCoursesCompleteData] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [discountedPrice, setDiscountedPrice] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [userId, setUserId] = useState('');
    const [getuserTenantCourseMapData, setuserTenantCourseMapData] = useState([]);
    const [getbulkTenantCourseMapData, setBulkTenantCourseMapData] = useState([]);
    const [templateDataLoaded, setTemplateDataLoaded] = useState(null);

    const [payLoading, setPayLoading] = useState(false);

    useEffect(() => {
        decodeUrlHandler();
    }, [])

    useEffect(() => {
        // Calculate the discounted price based on the selectedCard and totalUsers
        let discountPercentage = 0;

        if (selectedCard === 1) {
            discountPercentage = 0;
        } else if (selectedCard === 2) {
            if (totalUsers >= 5 && totalUsers <= 9) {
                discountPercentage = 0.25; // 25% discount
            } else if (totalUsers >= 10) {
                discountPercentage = 0.5; // 50% discount
            }
        } else if (selectedCard === 3) {
            discountPercentage = 0.5; // 50% discount
        } else if (selectedCard === 4) {
            discountPercentage = 0.5; // 50% discount
        } else if (selectedCard === 5) {
            discountPercentage = 0; // 25% discount
        } else if (selectedCard === 6) {
            discountPercentage = 0; // 30% discount
        } else if (selectedCard === 7) {
            discountPercentage = 0; // 40% discount
        }

        const newDiscountedPrice = totalPrice - (totalPrice * discountPercentage);
        setDiscountedPrice(newDiscountedPrice);

    }, [totalPrice, selectedCard, totalUsers]);


    useEffect(() => {



        if (email !== "chariot@cdac.in" && email !== undefined && email !== null) {
            service.getUserByEmail(email)
                .then(res => {

                    setUserDetails(res.data);
                    setUserId(res.data.learnerUsername);
                    if (res.data.authenticationId === 2) {
                        setIsVerified(true)
                    }
                    else {
                        setIsVerified(false)
                    }
                })
                .catch(err => {

                })
        }

        learnerService.getPublishCourses()
            .then(res => {

                const courseData = res.data.map((single) => {
                    return {
                        value: single.courseId,
                        label: single.courseName,
                    }
                })
                setCourses(courseData);
                setCoursesCompleteData(res.data);
            })
            .catch(err => {

            })
    }, [email])

    const decodeUrlHandler = () => {
        const secretKey = "cdac@123";

        const encodedEmail = props.match.params.email.replace(/-/g, "+").replace(/_/g, "/");
        const decodedEmail = CryptoJS.AES.decrypt(encodedEmail, secretKey).toString(CryptoJS.enc.Utf8);

        const encodedSelectedCard = props.match.params.selectedCard.replace(/-/g, "+").replace(/_/g, "/");
        const decodedSelectedCard = CryptoJS.AES.decrypt(encodedSelectedCard, secretKey).toString(CryptoJS.enc.Utf8);
        const selectedCardNumber = parseInt(decodedSelectedCard);

        setEmail(decodedEmail);
        setSelectedCard(selectedCardNumber);
    };
    // useEffect(() => { console.log("getuserTenantCourseMapData", getuserTenantCourseMapData, getCoursesCompleteData) }, [getuserTenantCourseMapData, getCoursesCompleteData])
    const handleSelectionChange = (selectedCourses) => {
        setSelectedCourses(selectedCourses);
        // console.log("selectcourse", selectedCourses)
        // alert("selectedCourses")
        setuserTenantCourseMapData([])
        let price = 0;
        //     selectedCourses.map((data) => {
        //         getCoursesCompleteData.map((item) => {
        //             if (item.courseId == data) {

        //                 if (selectedCard === 1 || selectedCard === 2 || selectedCard === 3 || selectedCard === 4) {
        //                     price = price + item.courseFee;
        //                 } else if (selectedCard === 5) {
        //                     price = price + item.cdacEmpCourseFee;
        //                 } else if (selectedCard === 6) {
        //                     price = price + item.corpUserCourseFee;
        //                 } else if (selectedCard === 7) {
        //                     price = price + item.apssdcStuCourseFee;
        //                 }

        //                 let tenantnCourse = {
        //                     userId: userId,
        //                     courseId: data,
        //                     tenantId: 1,
        //                     orderId: 0,
        //                     registrationType: selectedCard,
        //                     promo_code: null
        //                 }
        //                 // setuserTenantCourseMapData([...getuserTenantCourseMapData, tenantnCourse])
        //                 setuserTenantCourseMapData([...getuserTenantCourseMapData, tenantnCourse])

        //             }
        //         })
        //     }
        // )

        const tenantCourseMap = selectedCourses.reduce((acc, data) => {
            const matchedCourse = getCoursesCompleteData.find(item => item.courseId === data);

            if (matchedCourse) {
                let courseFee = 0;
                if (selectedCard === 1 || selectedCard === 2 || selectedCard === 3 || selectedCard === 4) {
                    courseFee = matchedCourse.courseFee;
                } else if (selectedCard === 5) {
                    courseFee = matchedCourse.cdacEmpCourseFee;
                } else if (selectedCard === 6) {
                    courseFee = matchedCourse.corpUserCourseFee;
                } else if (selectedCard === 7) {
                    courseFee = matchedCourse.apssdcStuCourseFee;
                }

                price += courseFee; // Update total price

                const tenantnCourse = {
                    userId: userId,
                    courseId: data,
                    tenantId: 1,
                    orderId: 0,
                    registrationType: selectedCard,
                    promo_code: null,
                };

                acc.push(tenantnCourse); // Accumulate the data
            }

            return acc;
        }, []);

        // Update the state with the final tenantCourseMap array
        setuserTenantCourseMapData(tenantCourseMap);

        setTotalPrice(price);
    };



    const handleExcelTemplateClick = () => {
        setShowExcelTemplate(!showExcelTemplate);
        setShowAddUsers(false);
    };

    const handleAddUsersManuallyClick = () => {
        setShowAddUsers(!showAddUsers);
        setShowExcelTemplate(false);
    };

    const addRow = () => {
        if (multiUserDetails.length < 50) {
            setMultiUserDetails([...multiUserDetails, {}]);
        }
    };

    const removeRow = (index) => {
        setMultiUserDetails(multiUserDetails.filter((_, i) => i !== index));
    };

    // const handleInputChange = (e, index) => {
    //     const { name, value } = e.target;
    //     const updatedUserDetails = [...multiUserDetails];
    //     updatedUserDetails[index] = {
    //         ...updatedUserDetails[index],
    //         [name]: value
    //     };
    //     setMultiUserDetails(updatedUserDetails);
    // };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedUserDetails = [...multiUserDetails];

        // Initialize error fields if not already present
        if (!updatedUserDetails[index].errors) {
            updatedUserDetails[index].errors = {};
        }

        updatedUserDetails[index] = {
            ...updatedUserDetails[index],
            [name]: value
        };

        setMultiUserDetails(updatedUserDetails);
    };

    ////////////////////////VALIDATIONS////////////////////////////////////
    const handleFirstNameBlur = (e, index) => {
        const { value } = e.target;
        const updatedUserDetails = [...multiUserDetails];

        // Initialize error fields if not already present
        if (!updatedUserDetails[index].errors) {
            updatedUserDetails[index].errors = {};
        }

        if (value === "") {
            updatedUserDetails[index].errors.firstName = "*Enter your First Name";
        } else if (value.length < 3) {
            updatedUserDetails[index].errors.firstName = "*Must have at least 3 letters";
        } else if (!/^[A-Za-z]+$/.test(value)) {
            updatedUserDetails[index].errors.firstName = "*First Name can only contain letters";
        } else {
            updatedUserDetails[index].errors.firstName = null;
        }

        setMultiUserDetails(updatedUserDetails);
    };

    const handleLastNameBlur = (e, index) => {
        const { value } = e.target;
        const updatedUserDetails = [...multiUserDetails];

        // Initialize error fields if not already present
        if (!updatedUserDetails[index].errors) {
            updatedUserDetails[index].errors = {};
        }

        if (value === "") {
            updatedUserDetails[index].errors.lastName = "*Enter your Last Name";
        } else if (value.length < 3) {
            updatedUserDetails[index].errors.lastName = "*Must have at least 3 letters";
        } else if (!/^[A-Za-z]+$/.test(value)) {
            updatedUserDetails[index].errors.lastName = "*Last Name can only contain letters";
        } else {
            updatedUserDetails[index].errors.lastName = null;
        }

        setMultiUserDetails(updatedUserDetails);
    };

    const handleEmailBlur = (e, index) => {
        const { value } = e.target;
        const updatedUserDetails = [...multiUserDetails];

        // Initialize error fields if not already present
        if (!updatedUserDetails[index].errors) {
            updatedUserDetails[index].errors = {};
        }

        if (!value) {
            updatedUserDetails[index].errors.emailId = "*Please enter your email";
        } else if (!isValidEmail(value)) {
            updatedUserDetails[index].errors.emailId = "*Please provide a valid email";
        } else {
            updatedUserDetails[index].errors.emailId = null;
        }

        setMultiUserDetails(updatedUserDetails);
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        return emailRegex.test(email);
    };

    const handleMobileNumberBlur = (e, index) => {
        const { value } = e.target;
        const updatedUserDetails = [...multiUserDetails];

        // Initialize error fields if not already present
        if (!updatedUserDetails[index].errors) {
            updatedUserDetails[index].errors = {};
        }

        if (!value) {
            updatedUserDetails[index].errors.mobileNo = "*Please enter your mobile number";
        } else if (value.length !== 10) {
            updatedUserDetails[index].errors.mobileNo = "*Mobile number should be 10 digits long";
        } else if (!isValidNumber(value)) {
            updatedUserDetails[index].errors.mobileNo = "*Please enter a valid number";
        } else {
            updatedUserDetails[index].errors.mobileNo = null;
        }

        setMultiUserDetails(updatedUserDetails);
    };

    const isValidNumber = (number) => {
        const numberRegex = /^[6-9]\d{9}$/;
        return numberRegex.test(number);
    };


    /////////////////////////////////////////////////////////////////////////////////////

    const handleMultiSelectionChange = (selectedOptions, index) => {
        const updatedUserDetails = [...multiUserDetails];
        updatedUserDetails[index] = {
            ...updatedUserDetails[index],
            selectedOptions
        };
        setMultiUserDetails(updatedUserDetails);
    };
    useEffect(() => {
        if (multiUserDetails && multiUserDetails.length > 0 && getCoursesCompleteData && getCoursesCompleteData.length > 0) {
            let price = 0;

            multiUserDetails.forEach((user) => {
                if (user.selectedOptions && user.selectedOptions.length > 0) {
                    user.selectedOptions.forEach((data) => {
                        const course = getCoursesCompleteData.find((item) => item.courseId === data);
                        if (course) {

                            if (selectedCard === 1 || selectedCard === 2 || selectedCard === 3 || selectedCard === 4) {
                                price = price + course.courseFee;
                            } else if (selectedCard === 5) {
                                price = price + course.cdacEmpCourseFee;
                            } else if (selectedCard === 6) {
                                price = price + course.corpUserCourseFee;
                            } else if (selectedCard === 7) {
                                price = price + course.apssdcStuCourseFee;
                            }
                        }
                    });
                }
            });

            setTotalPrice(price);
        }
        setTotalUsers(multiUserDetails.length)
    }, [multiUserDetails, getCoursesCompleteData]);


    // const handleFileUpload = (e) => {
    //     const file = e.target.files[0];
    //     const reader = new FileReader();

    //     reader.onload = function (e) {
    //         const data = new Uint8Array(e.target.result);
    //         const workbook = XLSX.read(data, { type: 'array' });
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];
    //         const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

    //         const keys = jsonData[0];
    //         const parsedData = jsonData.slice(1).map((row) => {
    //             const obj = {};
    //             row.forEach((value, index) => {
    //                 obj[keys[index]] = value;
    //             });
    //             obj.selectedOptions = []; // Add an empty selectedCourses column
    //             return obj;
    //         });

    //         setTemplateDataLoaded(true);
    //         setMultiUserDetails(parsedData);
    //     };

    //     reader.readAsArrayBuffer(file);
    // };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.onload = function (e) {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const keys = jsonData[0];
            const parsedData = jsonData.slice(1).map((row) => {
                const obj = {};
                row.forEach((value, index) => {
                    obj[keys[index]] = value;
                });
                if (!obj.errors) {
                    obj.errors = {}; // Initialize error fields if not already present
                }
                obj.selectedOptions = []; // Add an empty selectedCourses column
                return obj;
            });

            setTemplateDataLoaded(true);
            setMultiUserDetails(parsedData);
            setTotalUsers(parsedData.length);
        };

        reader.readAsArrayBuffer(file);
    };


    const [clientId, setClientId] = useState();

    const redirecrToCourse = (email, selectedCard) => {

        // const secretKey = "cdac@123"

        // const encodedCourseId = CryptoJS.AES.encrypt(
        //     `${id}`,
        //     secretKey
        // ).toString();
        // const safeEncodedCourseId = encodedCourseId
        //     .replace(/\+/g, "-")
        //     .replace(/\//g, "_")
        //     .replace(/=+$/, "");

        // const encodedTenantId = CryptoJS.AES.encrypt(
        //     `${tid}`,
        //     secretKey
        // ).toString();
        // const safeEncodedTenantId = encodedTenantId
        //     .replace(/\+/g, "-")
        //     .replace(/\//g, "_")
        //     .replace(/=+$/, "");

        //history.push(`${process.env.PUBLIC_URL + "/registration-table/"}${email}/${selectedCard}`);

    }

    function paymentReceipt(orderId, selectedCard) {

        let tenantId = 0;
        let courseId = "";

        if (selectedCard == 2 || selectedCard == 3) {
            getbulkTenantCourseMapData.map(data => {
                courseId = courseId + data.courseId + "#";
                tenantId = data.tenantId;
            })
        }
        else {
            getuserTenantCourseMapData.map(data => {
                courseId = courseId + data.courseId + "#";
                tenantId = data.tenantId;
            })
        }


        const encodedCourseId = courseId
            .replace(/\#/g, "U");



        //history.push(`${process.env.PUBLIC_URL + "/Payment/"}${encodedCourseId}/${tenantId}/${orderId}`);


        history.push(`${process.env.PUBLIC_URL + "/PaymentwhileRegistration/"}${encodedCourseId}/${tenantId}/${orderId}`);
    }

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }




    const paymentForCourse = async (coursetenantdata) => {
        setPayLoading(true);
        // console.log("coursetenantdata--------> ", coursetenantdata)
        // alert("coursetenantdata")
        let data = {
            userTenantCourseMapPojoList: coursetenantdata,
            userId: userId,
            learner: userDetails.firstName,
            email: userDetails.email,
            mobile: userDetails.mobile,
        }

        await service.paymentDetailSaveWhileRegistration(data, selectedCard)
            .then(res => {

                if (res.data == "zero-amount-to-pay") {
                    swal(
                        t("course_enrolled_successfully"),
                        t("course_enrolled_successfully_alert"),
                        "success"
                    );
                    // history.push(`${process.env.PUBLIC_URL + "/"}`);
                    UserService.doLogin();
                    return;
                }


                const TokenJsonString = JSON.stringify(res.data);
                //  let encoded = encodeURIComponent(res.data);
                // //setOrderId(res.data.orderId)



                const form = document.createElement('form');
                form.method = 'post';
                form.action = `${URI.SERVER?._PAYMENT_GATEWAY}/cdachydpaymentgateway/pg/client/initPay`;


                const hiddenField = document.createElement('input');
                hiddenField.type = 'hidden';
                hiddenField.name = 'jsonToken';
                hiddenField.value = res.data;

                //hiddenField.value = "{ clientId : cdac.hyd.chariot, requestToken : eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..4il_-eohyxyjSmXQy0ygBw.GRZZ5I7we8wwEB9eXEbxBZP6EPjhf3V5PY2x92bufA0-jEZtf-R8HHIUDoFz4qXFTRPKsNMzVXAZwU_EJEBJ_fYfPAjCibnZRZQHGT_995QBPVrCUmGcOIXf79C7bpUmIh4hDFXRFXvLKenBLJbicE-1Fae675oThqiYZZ2pzdPsAcaPrwZPsiYTvnpIVyp3saO0h3kk3bhsPo_pQF_8t9Ok3HSBqv-fs3LELEbsrqAQE_Z_ms4YEi0fRG6uW6M3Jr--s2kGuZF1Zsi-4nNcsht_NvylhqwIV6ObPJqinHjiqpYrv0wEheQpsG-zkf04lcyTUpMHLRWZpk4uVOvHdaWNdI8uuTm0_0W4TOZPOMrrKLszDgcOLU64mJedd6i-kOXIL2Kw9oOyX9eh1xQXnpbdR5owwh-Yd4COo1xKJOTgNiDUPoYDlgMhfBkIp1zwgXtQo66i6dBeaFo6XkTzwrXlenRwW1N9UMVjQqpjHVZniS_3CBfWgdN64TsJDo5JeFOc1icD00bWFulw9ir6YqV9CWcFi8_Jiu51PTRsZ14.-qcJIb3Zpe2irwqwcln5pg}";
                // hiddenField.value = "{ clientId : cdac.hyd.chariot, requestToken : eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..KUkdrntsDut5As8X6qkPEg.IyVfYSS3X2w5ybBpSyICSUnXczfRwPdkiNFvGPIySGLVhw_yWEnlL_ei2KyfsnkOeIdI-8kkEpQ0yPtu0iWQ1QeqeegR_boGBNnT9I_xM2zUyg5ICjxefaf0ZPfCyCygQmZGGxuiCEzIgNRsfSRr8Onyu5EGemFuQb2QzeRg-ZBipi-VRlk__cBIwchy2OW3JjGmf4AkplroOiYqJVtzEOzx0fQVLSrupfCHO5vMmCP2QdFZLc5jcJ1AuNSRXcAgCnVJlm2afw4nYlzwdLT5Ce1chS6qQBMLpOxUMs7qtKEVw5KpFbras9mPM4AQZEwpZxY_9C7BV9zY-VqP0UV67EXkedskftfUUXH_CIDgq1jKvKgebAEwB2_wt1_kkQ0tlu0WO4hGx27TszGlgMUHYL7xQDv_89ByxMXlJcxcUhfxcgOjhDTcA1_23tsLDjH1ZIy9JnQGhIoU48z1H4OWL5ArfRx21lKheo4UB94nkCXnkMvGF6NaUkRtTFJKFi22RvKpZ_M5hkMvzCImEw9xH2i8NAl-VE3le4RwFker17A.I7P1Yh79WgOout1tjd3GgQ}";

                form.appendChild(hiddenField);
                document.body.appendChild(form);
                form.submit();


                // if (res.data.orderId !== " ") {
                //     let orderId = res.data.orderId;
                //     let fees = res.data.fees;

                //     service.getOrderIdwhileRegistration(fees, orderId)
                //         .then(res => {
                //             if (res.status == '200') {
                //                 
                //                 
                //                 //setGenratedOrderId(res.data.orderID);
                //                 setClientId(res.data.ClientId);
                //                 service.updateRazorOrderidwhileRegistration(orderId, res.data.orderID)
                //                     .then(res => {
                //                         
                //                         
                //                         displayRazorpay(orderId, res.data.razorOrderId);
                //                     })
                //                     .catch(err => {

                //                     })
                //             }
                //         })
                //         .catch(err => {

                //         })
                // }
                // setPayLoading(false);
            })
            .catch(err => {
                setPayLoading(false);

            })

    }

    const bulkPaymentForCourse = async () => {
        setPayLoading(true);


        let bulkregistrationdata = [];

        let bulkpaymentdata = [];

        let status = true;

        // console.log("multiUserDetails------>  ", multiUserDetails);

        multiUserDetails.map((learner, index) => {

            const updatedUserDetails = [...multiUserDetails];

            // Initialize error fields if not already present
            if (!updatedUserDetails[index].errors) {
                updatedUserDetails[index].errors = {};
            }

            if (!learner.emailId) {
                updatedUserDetails[index].errors.emailId = "*Please enter your email";
            } else if (!isValidEmail(learner.emailId)) {
                updatedUserDetails[index].errors.emailId = "*Please provide a valid email";
            } else {
                updatedUserDetails[index].errors.emailId = null;
            }

            if (learner.firstName === "") {
                updatedUserDetails[index].errors.firstName = "*Enter your First Name";
                status = false;
            } else if (learner.firstName.length < 3) {
                updatedUserDetails[index].errors.firstName = "*Must have at least 3 letters";
                status = false;
            } else if (!/^[A-Za-z]+$/.test(learner.firstName)) {
                updatedUserDetails[index].errors.firstName = "*First Name can only contain letters";
                status = false;
            } else {
                updatedUserDetails[index].errors.firstName = null;
            }

            if (learner.lastName === "") {
                updatedUserDetails[index].errors.lastName = "*Enter your Last Name";
                status = false;
            } else if (learner.lastName.length < 3) {
                updatedUserDetails[index].errors.lastName = "*Must have at least 3 letters";
                status = false;
            } else if (!/^[A-Za-z]+$/.test(learner.lastName)) {
                updatedUserDetails[index].errors.lastName = "*Last Name can only contain letters";
                status = false;
            } else {
                updatedUserDetails[index].errors.lastName = null;
            }

            let mobileno = learner.mobileNo;
            // console.log("learner.mobileNo length------> ", mobileno.length);

            if (!learner.mobileNo) {
                updatedUserDetails[index].errors.mobileNo = "*Please enter your mobile number";
                status = false;
                // } else if (mobileno !== undefined && mobileno.length !== 10) {
                //     updatedUserDetails[index].errors.mobileNo = "*Mobile number should be 10 digits long";
                //     status = false;
            } else if (!isValidNumber(learner.mobileNo)) {
                updatedUserDetails[index].errors.mobileNo = "*Please enter a valid number";
                status = false;
            } else {
                updatedUserDetails[index].errors.mobileNo = null;
            }

            setMultiUserDetails(updatedUserDetails);

            let bulkData = {
                firstName: learner.firstName,
                lastName: learner.lastName,
                mobileNo: learner.mobileNo,
                emailId: learner.emailId,
                registrationType: selectedCard,
                promo_code: null
            }
            bulkregistrationdata.push(bulkData);
        })

        // console.log("bulkregistrationdata--------> ", bulkregistrationdata);


        if (status == true) {
            await adminServices.bulkUserUploadChariot(bulkregistrationdata)
                .then(async res => {

                    let count = 0;
                    await res.data.map(async (bulkresult) => {
                        if (bulkresult.status === "Success" || bulkresult.status === "Exist") {
                            await multiUserDetails.map(async (learner) => {
                                if (learner.emailId === bulkresult.emailId) {
                                    await service.getUserByEmail(learner.emailId)
                                        .then(async res => {

                                            if (count === 0 && selectedCard == 2) {
                                                setUserDetails(res.data);
                                                setUserId(res.data.learnerUsername);
                                            }
                                            await learner.selectedOptions.map((courses) => {
                                                let tenantnCourse = {
                                                    userId: res.data.learnerUsername,
                                                    courseId: courses,
                                                    tenantId: 1,
                                                    orderId: 0
                                                }
                                                bulkpaymentdata.push(tenantnCourse);
                                                let count2 = 0;
                                                multiUserDetails.map((learner) => {
                                                    learner.selectedOptions.map((courses) => {
                                                        if (courses !== null) {
                                                            count2 = count2 + 1;
                                                        }
                                                    })
                                                })
                                                if (bulkpaymentdata.length == count2) {
                                                    setBulkTenantCourseMapData(bulkpaymentdata);
                                                }

                                            })
                                        })
                                        .catch(err => {

                                        })

                                }
                            })
                        }
                    })
                    setPayLoading(false);
                })
                .catch(err => {

                    setPayLoading(false);
                })
        }
        else {
            setPayLoading(false);
        }
    }




    useEffect(() => {
        let count = 0;
        if (JSON.stringify(multiUserDetails[0]) !== '{}') {
            multiUserDetails.map((learner) => {
                learner.selectedOptions.map((courses) => {
                    if (courses !== null) {
                        count = count + 1;
                    }
                })
            })

            if (getbulkTenantCourseMapData.length === count) {

                paymentForCourse(getbulkTenantCourseMapData);
            }
        }
    }, [getbulkTenantCourseMapData])

    return (
        <Styles>
            <HeaderTwo className="header-above" />
            <BreadcrumbBox2 title="Registration" />
            <section className='registration-table-page'>
                <section className='registration-table-area'>
                    {/* <Container style={{ width: '1800px' }}> */}
                    {(selectedCard != 2) && (
                        <section className='registration-user-details'>
                            {(selectedCard == 7) && (
                                <div className='image-container-apssdc'>
                                    <img
                                        src={process.env.PUBLIC_URL + `/assets/images/cdac1.png`}
                                        alt="cdac logo"
                                        style={{ height: "80px" }}
                                    />
                                    <img
                                        src={process.env.PUBLIC_URL + `/assets/images/apssdc.png`}
                                        alt="appsdc logo"
                                        style={{ height: "80px" }}
                                    />
                                </div>
                            )}
                            <header className='registration-header text-center'>
                                <h3>Course(s) Selection: </h3>
                                <br></br>
                            </header>
                            {(selectedCard == 3) && (
                                <div className='mb-1'>
                                    <h4>Officer Detail:</h4>
                                </div>
                            )}
                            {(selectedCard == 1 ||
                                selectedCard == 3 ||
                                selectedCard == 4 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <Row>
                                        <Col md={3}>
                                            <div className='form-field'>
                                                <label>Email:</label>
                                                <input
                                                    type='email'
                                                    placeholder='Email'
                                                    value={userDetails?.email}
                                                    disabled={true}
                                                />
                                            </div>
                                        </Col>

                                        <Col md={3}>
                                            <div className='form-field'>
                                                <label>First Name:</label>
                                                <input
                                                    type='text'
                                                    placeholder='First Name'
                                                    value={userDetails?.firstName}
                                                    disabled={true}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className='form-field'>
                                                <label>Last Name:</label>
                                                <input
                                                    type='text'
                                                    placeholder='Last Name'
                                                    value={userDetails?.lastName}
                                                    disabled={true}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <div className='form-field'>
                                                <label>Mobile:</label>
                                                <input
                                                    type='text'
                                                    placeholder='Mobile Number'
                                                    value={userDetails?.mobile}
                                                    disabled={true}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={1} className='d-flex align-items-center'>
                                            <div className='form-field verification-icon'>
                                                <label className='mb-2'>Verified:</label>
                                                {isVerified ? (
                                                    <p className='icons icon-check'>
                                                        <i className="fa fa-check-circle"></i>
                                                    </p>
                                                ) : (
                                                    <p className='icons icon-cross'>
                                                        <i className="fa fa-times-circle"></i>
                                                    </p>
                                                )}
                                            </div>
                                        </Col>

                                    </Row>
                                )}
                            {(selectedCard == 1 ||
                                selectedCard == 4 ||
                                selectedCard == 5 ||
                                selectedCard == 6 ||
                                selectedCard == 7) && (
                                    <>
                                        <Row>
                                            <Col md={8}>
                                                <div className='form-field'>
                                                    <label>Select Course:</label>

                                                    <DropdownMenuComponent
                                                        onSelectionChange={handleSelectionChange}
                                                        getCourses={getCourses}
                                                        selectedValues={selectedCourses}
                                                    />

                                                    {/* <ReactSelect options={getCourses} isMulti onChange={handleSelectionChange} /> */}
                                                </div>
                                            </Col>
                                            <Col md={4}>
                                                <div className='price-display'>
                                                    <label >Price:</label>
                                                    <h3>₹ {discountedPrice}</h3>
                                                </div>
                                            </Col>
                                        </Row>
                                        <br></br>
                                        <Row>
                                            <Col md={12} className='form-field d-flex justify-content-center'>
                                                <Button
                                                    variant="success"
                                                    className="refresh-button"
                                                    onClick={() => paymentForCourse(getuserTenantCourseMapData)}
                                                    disabled={payLoading || (selectedCourses.length == 0)}
                                                >
                                                    {payLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Proceed to Payment</>}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                        </section>
                    )}
                    {(selectedCard == 3) && (
                        <section className='college-registration-area mb-5'>
                            <Row>
                                <Col md={12} className='college-template-area text-center'>

                                    {true && (
                                        <Row>
                                            <Col md={12} className='bulk-template-button text-center' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                                <div style={{ flex: 1, textAlign: 'center' }}>
                                                    <div className='file-upload'>
                                                        <div className='file-input'>

                                                            <div className='template-download-button'>
                                                                <a
                                                                    className='template-download-link'
                                                                    href={process.env.PUBLIC_URL + `/assets/images/collegeTemplate.xls`}
                                                                    download="template.xlsx"
                                                                >
                                                                    Download Template
                                                                </a>
                                                            </div>
                                                            <input type="file" accept=".xlsx, .csv" onChange={handleFileUpload} title='Upload File' />
                                                        </div>
                                                        <p className='file-note'>Note: Download the Template, fill it up with the details and then Upload the file!</p>
                                                    </div>
                                                </div>
                                                {(templateDataLoaded) && (
                                                    <div>
                                                        <label>Price:</label>
                                                        <h4 style={{ color: "#06488f", fontWeight: "bold" }}>₹ {discountedPrice}</h4>
                                                    </div>
                                                )}
                                            </Col>
                                            <Col md={12}>
                                                {
                                                    templateDataLoaded && (

                                                        <div className='scrollable-container mt-5'>
                                                            <table>
                                                                <thead>
                                                                    <tr>
                                                                        <th>SNo</th>
                                                                        <th>Email</th>
                                                                        <th>First Name</th>
                                                                        <th>Last Name</th>
                                                                        <th>Mobile</th>
                                                                        <th>College/Organisation</th>
                                                                        <th>Select Course</th>
                                                                        {multiUserDetails.length > 50 && (<th>Action</th>)}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {multiUserDetails?.map((user, index) => (
                                                                        <tr key={index}>
                                                                            <td>
                                                                                {index + 1}
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type='email'
                                                                                    placeholder='Email'
                                                                                    name='emailId'
                                                                                    value={user.emailId || ''}
                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                    onBlur={(e) => handleEmailBlur(e, index)}
                                                                                />
                                                                                {user.errors && user.errors.emailId && <div className="error-message">{user.errors.emailId}</div>}
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type='text'
                                                                                    placeholder='First Name'
                                                                                    name='firstName'
                                                                                    value={user.firstName || ''}
                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                    onBlur={(e) => handleFirstNameBlur(e, index)}
                                                                                />
                                                                                {user.errors && user.errors.firstName && <div className="error-message">{user.errors.firstName}</div>}
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type='text'
                                                                                    placeholder='Last Name'
                                                                                    name='lastName'
                                                                                    value={user.lastName || ''}
                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                    onBlur={(e) => handleLastNameBlur(e, index)}
                                                                                />
                                                                                {user.errors && user.errors.lastName && <div className="error-message">{user.errors.lastName}</div>}
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type='text'
                                                                                    placeholder='Mobile Number'
                                                                                    name='mobileNo'
                                                                                    value={user.mobileNo || ''}
                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                    onBlur={(e) => handleMobileNumberBlur(e, index)}
                                                                                    maxLength={10}
                                                                                />
                                                                                {user.errors && user.errors.mobileNo && <div className="error-message">{user.errors.mobileNo}</div>}
                                                                            </td>
                                                                            <td>
                                                                                <input
                                                                                    type='text'
                                                                                    placeholder='College/Organisation Name'
                                                                                    name='college'
                                                                                    value={user.college || ''}
                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                />
                                                                            </td>
                                                                            <td>
                                                                                <div className='dropdown-area'>
                                                                                    <DropdownMenuComponent
                                                                                        onSelectionChange={(selectedOptions) =>
                                                                                            handleMultiSelectionChange(selectedOptions, index)
                                                                                        }
                                                                                        getCourses={getCourses}
                                                                                        selectedValues={user.selectedOptions || []}
                                                                                    />
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                {multiUserDetails.length > 5 && (
                                                                                    <button className='remove-row-icon' type='button' onClick={() => removeRow(index)}>
                                                                                        <i className="fa fa-times-circle"></i>
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>

                                                            {multiUserDetails.length < 50 && (
                                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px', }}>
                                                                    <button className='add-row-icon' type='button' onClick={addRow}>
                                                                        <i className="fa fa-plus-circle"></i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>

                                                    )
                                                }
                                            </Col>
                                        </Row>
                                    )}
                                </Col>
                            </Row>
                            {templateDataLoaded && (
                                <Row className='mt-2'>
                                    <Col md={4}>

                                        <div className=''>
                                            <label >Price:</label>
                                            <h4 style={{ color: "#06488f", fontWeight: "bold" }}>₹ {discountedPrice}</h4>
                                        </div>

                                    </Col>
                                    <Col md={4} className='d-flex justify-content-center'>
                                        <Button variant="success" className="refresh-button" onClick={bulkPaymentForCourse}>
                                            {payLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Proceed to Payment</>}
                                        </Button>
                                    </Col>
                                    <Col md={4} className='d-flex justify-content-end'>

                                    </Col>
                                </Row>
                            )}
                        </section>
                    )}
                    {(selectedCard == 2) && (
                        <section className='bulk-registration-area mb-5'>
                            <header className='bulk-registration-header text-center'>
                                <h4>Select a Upload Method </h4>
                            </header>
                            <Row>
                                <Col md={12} className='bulk-template-button text-center' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ flex: 1, textAlign: 'center' }}>
                                        <Button
                                            onClick={handleExcelTemplateClick}
                                            className={`${showExcelTemplate ? 'active' : ''}`}
                                            style={{ marginRight: '5px' }}
                                        >
                                            Upload Excel Template
                                        </Button>
                                        <Button
                                            onClick={handleAddUsersManuallyClick}
                                            className={`${showAddUsers ? 'active' : ''}`}
                                            style={{ marginLeft: '5px' }}
                                        >
                                            Add Users Manually
                                        </Button>
                                    </div>
                                    {(templateDataLoaded || showAddUsers) && (
                                        <div>
                                            <label>Price:</label>
                                            <h4 style={{ color: "#06488f", fontWeight: "bold" }}>₹ {discountedPrice}</h4>
                                        </div>
                                    )}
                                </Col>

                                <Col md={12} className='bulk-template-area text-center'>
                                    {showExcelTemplate && (
                                        <Row>
                                            <Col md={12}>
                                                <div className=''>
                                                    <div className='file-upload'>
                                                        <div className='file-input'>
                                                            <div className='template-download-button'>
                                                                <a
                                                                    className='template-download-link'
                                                                    href={process.env.PUBLIC_URL + `/assets/images/bulkTemplate.xls`}
                                                                    download="template.xlsx"
                                                                >
                                                                    Download Template
                                                                </a>
                                                            </div>
                                                            <input type="file" accept=".xlsx, .csv" onChange={handleFileUpload} title='Upload File' />
                                                        </div>
                                                        <p className='file-note'>Note: Download the Template, fill it up with the details and then Upload the file!</p>
                                                    </div>
                                                    {
                                                        templateDataLoaded && (

                                                            <div className='scrollable-container mt-5'>
                                                                <table>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>SNo</th>
                                                                            <th>Email</th>
                                                                            <th>First Name</th>
                                                                            <th>Last Name</th>
                                                                            <th>Mobile</th>
                                                                            <th>Select Course</th>
                                                                            {multiUserDetails.length > 5 && (<th>Action</th>)}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {multiUserDetails?.map((user, index) => (
                                                                            <tr key={index}>
                                                                                <td>
                                                                                    {index + 1}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type='email'
                                                                                        placeholder='Email'
                                                                                        name='emailId'
                                                                                        value={user.emailId || ''}
                                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                                        onBlur={(e) => handleEmailBlur(e, index)}
                                                                                    />
                                                                                    {user.errors && user.errors.emailId && <div className="error-message">{user.errors.emailId}</div>}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type='text'
                                                                                        placeholder='First Name'
                                                                                        name='firstName'
                                                                                        value={user.firstName || ''}
                                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                                        onBlur={(e) => handleFirstNameBlur(e, index)}
                                                                                    />
                                                                                    {user.errors && user.errors.firstName && <div className="error-message">{user.errors.firstName}</div>}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type='text'
                                                                                        placeholder='Last Name'
                                                                                        name='lastName'
                                                                                        value={user.lastName || ''}
                                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                                        onBlur={(e) => handleLastNameBlur(e, index)}
                                                                                    />
                                                                                    {user.errors && user.errors.lastName && <div className="error-message">{user.errors.lastName}</div>}
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        type='text'
                                                                                        placeholder='Mobile Number'
                                                                                        name='mobileNo'
                                                                                        value={user.mobileNo || ''}
                                                                                        onChange={(e) => handleInputChange(e, index)}
                                                                                        onBlur={(e) => handleMobileNumberBlur(e, index)}
                                                                                        maxLength={10}
                                                                                    />
                                                                                    {user.errors && user.errors.mobileNo && <div className="error-message">{user.errors.mobileNo}</div>}
                                                                                </td>
                                                                                <td>
                                                                                    <div className='dropdown-area'>
                                                                                        <DropdownMenuComponent
                                                                                            onSelectionChange={(selectedOptions) =>
                                                                                                handleMultiSelectionChange(selectedOptions, index)
                                                                                            }
                                                                                            getCourses={getCourses}
                                                                                            selectedValues={user.selectedOptions || []}
                                                                                        />
                                                                                    </div>
                                                                                </td>
                                                                                <td>
                                                                                    {multiUserDetails.length > 5 && (
                                                                                        <button className='remove-row-icon' type='button' onClick={() => removeRow(index)}>
                                                                                            <i className="fa fa-times-circle"></i>
                                                                                        </button>
                                                                                    )}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>

                                                                {multiUserDetails.length < 50 && (
                                                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px', }}>
                                                                        <button className='add-row-icon' type='button' onClick={addRow}>
                                                                            <i className="fa fa-plus-circle"></i>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                </Col>

                                <Col md={12} className='manual-add-area text-center'>
                                    {showAddUsers && (
                                        <div className='scrollable-container mt-5'>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>SNo</th>
                                                        <th>Email</th>
                                                        <th>First Name</th>
                                                        <th>Last Name</th>
                                                        <th>Mobile</th>
                                                        <th>Select Course</th>
                                                        {multiUserDetails.length > 5 && (<th>Action</th>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {multiUserDetails?.map((user, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {index + 1}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type='email'
                                                                    placeholder='Email'
                                                                    name='emailId'
                                                                    value={user.emailId || ''}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    onBlur={(e) => handleEmailBlur(e, index)}
                                                                />
                                                                {user.errors && user.errors.emailId && <div className="error-message">{user.errors.emailId}</div>}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type='text'
                                                                    placeholder='First Name'
                                                                    name='firstName'
                                                                    value={user.firstName || ''}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    onBlur={(e) => handleFirstNameBlur(e, index)}
                                                                />
                                                                {user.errors && user.errors.firstName && <div className="error-message">{user.errors.firstName}</div>}

                                                            </td>
                                                            <td>
                                                                <input
                                                                    type='text'
                                                                    placeholder='Last Name'
                                                                    name='lastName'
                                                                    value={user.lastName || ''}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    onBlur={(e) => handleLastNameBlur(e, index)}
                                                                />
                                                                {user.errors && user.errors.lastName && <div className="error-message">{user.errors.lastName}</div>}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type='text'
                                                                    placeholder='Mobile Number'
                                                                    name='mobileNo'
                                                                    value={user.mobileNo || ''}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    onBlur={(e) => handleMobileNumberBlur(e, index)}
                                                                    maxLength={10}
                                                                />
                                                                {user.errors && user.errors.mobileNo && <div className="error-message">{user.errors.mobileNo}</div>}
                                                            </td>
                                                            <td>
                                                                <div className='dropdown-area'>
                                                                    <DropdownMenuComponent
                                                                        onSelectionChange={(selectedOptions) =>
                                                                            handleMultiSelectionChange(selectedOptions, index)
                                                                        }
                                                                        getCourses={getCourses}
                                                                        selectedValues={user.selectedOptions || []}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {multiUserDetails.length > 5 && (
                                                                    <button className='remove-row-icon' type='button' onClick={() => removeRow(index)}>
                                                                        <i className="fa fa-times-circle"></i>
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            {multiUserDetails.length < 50 && (
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px', }}>
                                                    <button className='add-row-icon' type='button' onClick={addRow}>
                                                        <i className="fa fa-plus-circle"></i>
                                                    </button>
                                                </div>

                                            )}
                                        </div>

                                    )}
                                </Col>
                            </Row>
                            {(templateDataLoaded || showAddUsers) && (
                                <Row className='mt-2'>
                                    <Col md={4}>

                                        <div className=''>
                                            <label >Price:</label>
                                            <h4 style={{ color: "#06488f", fontWeight: "bold" }}>₹ {discountedPrice}</h4>
                                        </div>

                                    </Col>
                                    <Col md={4} className='d-flex justify-content-center'>
                                        <Button
                                            variant="success"
                                            className="refresh-button"
                                            onClick={bulkPaymentForCourse}
                                        >
                                            {payLoading ? <span class="spinner-border spinner-border-sm"></span> : <>Proceed to Payment</>}
                                        </Button>
                                    </Col>
                                    <Col md={4} className='d-flex justify-content-end'>

                                    </Col>
                                </Row>
                            )}

                        </section>
                    )}
                    {/* </Container> */}
                </section>
            </section>
            <FooterTwo />
        </Styles >
    );
};

export default RegisterTable;




